import { useEffect } from 'react';
import { SITE } from '../config/siteConfig';

const DEFAULT_DESC = 'Precision fibre laser cutting in Blacktown NSW. Upload a DXF, get an indicative quote, track orders and download mill certificates.';

/**
 * 페이지별 <title> · meta description. 라우트가 바뀌면 브라우저 탭·히스토리·검색 결과에
 * 페이지 이름이 남는다. 언마운트 시 기본값으로 되돌린다.
 */
export default function usePageTitle(title, description) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} — ${SITE.name}` : `${SITE.name} — Precision fibre laser cutting`;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta ? meta.getAttribute('content') : null;
    if (meta) meta.setAttribute('content', description || DEFAULT_DESC);
    return () => {
      document.title = prev;
      if (meta && prevDesc !== null) meta.setAttribute('content', prevDesc);
    };
  }, [title, description]);
}
